export const getPopupContainer = (triggerNode: HTMLElement): HTMLElement =>
  triggerNode.parentElement || document.body;
